import MUIModal from "@mui/material/Modal";
import styled from "@mui/material/styles/styled";

const Modal = styled(MUIModal)(() => ({}));

export default Modal;
